<template>
<div class="chapter">
<div class="inner_page">
<section>
<p class="titlePageTitle"><b>The Amish Innkeeper’s Secret</b></p>
<p class="titlePageAuthor"><i><b>Patricia Davids</b></i></p>
<p class="colophon"><img alt="image" src="images/logo.jpg"/></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780369704351_Title.vue?3a8b75d0